import atendimento from './atendimento.json'
import clientes from './clientes.json'
import common from './common.json'
import empreendimentos from './empreendimentos.json'
import enums from './enums.json'
import espelhoDeVendas from './espelho-de-vendas.json'
import historico from './historico.json'
import leadsRepresados from './leads-represados.json'
import login from './login.json'
import proposta from './proposta.json'
import simulacao from './simulacao.json'
import simulador from './simulador.json'

const ES_CL_LOCALE = {
  common,
  login,
  enums,
  'espelho-de-vendas': espelhoDeVendas,
  simulador,
  proposta,
  clientes,
  atendimento,
  historico,
  simulacao,
  empreendimentos,
  'leads-represados': leadsRepresados,
}

export default ES_CL_LOCALE
